import {Component, EventEmitter, Input, Output,} from '@angular/core';

@Component({
  selector: 'app-validation-error-badge',
  templateUrl: './validation-error-badge.component.html',
  styleUrls: ['./validation-error-badge.component.scss']
})
export class ValidationErrorBadgeComponent {
  @Input('activatorKey') activatorKey = null;
  @Input('validationErrors') validationErrors = null;

  shouldBeVisible(): boolean {
    if (null === this.activatorKey || null === this.validationErrors) {
      return false;
    }

    for (let key of Object.keys(this.validationErrors ?? {})) {
      if (this.activatorKey === key) {
        return true;
      }
    }

    return false;
  }

  text(): string {
    if (null === this.validationErrors) {
      return null;
    }

    for (let key of Object.keys(this.validationErrors ?? {})) {
      if (this.activatorKey === key) {
         return this.validationErrors[key][0];
      }
    }

    return null;
  }

  hide(): void {
    this.validationErrors = null;
  }
}
